export const permissionControl = (comp_name, index) => {
    //component name and crud index [1,1,1,1]
    try {
        let permissions = JSON.parse(localStorage.getItem("permissions"));
        // let onee = Object.keys(permissions).find(
        //     (item) => item.toLowerCase() === comp_name.toLowerCase()
        // );
        // if (onee.length > 0) {
        //     return !!permissions[onee][index];
        // } else {
        //     return false;
        // }

        if (superAdminControl() !== undefined) {
            return true;
        }
        if (index === "all") {
            return !permissions[comp_name].some((item) => item === 0);
        }
        if (permissions[comp_name] !== undefined) {
            return !!permissions[comp_name][index];
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

export const superAdminControl = () => {
    try {
        let user = JSON.parse(localStorage.getItem("jwt")).user;

        if (user !== undefined) {
            return user.superAdmin;
        }
    } catch (error) {
        return false;
    }
};
